import { Bot } from 'lucide-react'

interface Props {
  avatarUrl?: string
  onClick: () => void
  isOpen: boolean
}

export default function ButlerButton({ avatarUrl, onClick, isOpen }: Props) {
  return (
    <button
      onClick={onClick}
      className="relative h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 active:scale-95 overflow-hidden"
      style={{ backgroundColor: '#f97316' }}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="" className="h-14 w-14 rounded-full object-cover" />
      ) : (
        <div className="h-full w-full rounded-full flex items-center justify-center">
          <Bot className="h-6 w-6 text-white" />
        </div>
      )}

      {/* Pulse ring — overflow-hidden on parent clips the expanding ring */}
      {!isOpen && (
        <span className="absolute inset-0 rounded-full animate-ping opacity-20 pointer-events-none" style={{ backgroundColor: '#f97316' }} />
      )}
    </button>
  )
}
